import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { ElementType, ReactNode } from "react";

interface SectionHeadingProps {
  children: ReactNode;
  /** Optional leading icon. Rendered at reduced opacity, hidden from assistive technology. */
  icon?: ReactNode;
  /** Optional trailing content, such as a badge or action button. */
  action?: ReactNode;
  /** Underlying element. Defaults to "p"; pass "h2" or "h3" for card panel contexts. */
  component?: ElementType;
}

/**
 * Compact uppercase section label used as panel headers and category labels throughout the console.
 */
export function SectionHeading({ children, icon, action, component = "p" }: SectionHeadingProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, width: "100%" }}>
      {icon != null && (
        <Box
          component="span"
          aria-hidden="true"
          sx={{ display: "flex", alignItems: "center", opacity: 0.7, fontSize: "0.875rem" }}
        >
          {icon}
        </Box>
      )}
      <Typography
        component={component}
        variant="overline"
        sx={{
          fontWeight: 700,
          letterSpacing: "0.1em",
          color: "text.secondary",
          lineHeight: 1,
          flexGrow: 1,
        }}
      >
        {children}
      </Typography>
      {action != null && <Box>{action}</Box>}
    </Box>
  );
}
